import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import { ToastProvider } from './components/Toast';
import ProtectedRoute from './auth/ProtectedRoute';
import ConsoleLayout from './layout/ConsoleLayout';

import LoginScreen from './pages/auth/LoginScreen';
import AdminDashboard from './pages/dashboard/AdminDashboard';
import ProviderDashboard from './pages/provider/ProviderDashboard';
import TodaysQueuePage from './pages/provider/TodaysQueuePage';
import BusinessesPage from './pages/businesses/BusinessesPage';
import BusinessDetailPage from './pages/businesses/BusinessDetailPage';
import QueuesPage from './pages/queues/QueuesPage';
import QueueDetailPage from './pages/queues/QueueDetailPage';
import ConsumersPage from './pages/consumers/ConsumersPage';
import ConsumerDetailPage from './pages/consumers/ConsumerDetailPage';
import CategoriesPage from './pages/categories/CategoriesPage';
import PaymentsPage from './pages/payments/PaymentsPage';
import PaymentDetailPage from './pages/payments/PaymentDetailPage';
import TrialSettingsPage from './pages/settings/TrialSettingsPage';
import ProviderReportsPage from './pages/reports/ProviderReportsPage';
import AdminReportsPage from './pages/reports/AdminReportsPage';

/**
 * Routing
 * --------
 *  1. Bare zone — /login (id + password), self-guarded.
 *  2. Console zone — everything under <ConsoleLayout/>, guarded by <ProtectedRoute/>.
 */
function App(): React.ReactElement {
  return (
    <ToastProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/login" element={<LoginScreen />} />

          <Route
            element={
              <ProtectedRoute>
                <ConsoleLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<AdminDashboard />} />
            <Route path="/provider-dashboard" element={<ProviderDashboard />} />
            <Route path="/todays-queue" element={<TodaysQueuePage />} />

            <Route path="/businesses" element={<BusinessesPage />} />
            <Route path="/businesses/:id" element={<BusinessDetailPage />} />
            <Route path="/businesses/:id/dashboard" element={<ProviderDashboard />} />
            <Route path="/queues" element={<QueuesPage />} />
            <Route path="/queues/:id" element={<QueueDetailPage />} />
            <Route path="/consumers" element={<ConsumersPage />} />
            <Route path="/consumers/:id" element={<ConsumerDetailPage />} />
            <Route path="/categories" element={<CategoriesPage />} />
            <Route path="/payments" element={<PaymentsPage />} />
            <Route path="/payments/:id" element={<PaymentDetailPage />} />
            <Route path="/trial-settings" element={<TrialSettingsPage />} />

            <Route path="/provider-reports" element={<ProviderReportsPage />} />
            <Route path="/admin-reports" element={<AdminReportsPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;
